<template>
  <!--  产品中心 -->
  <div class="">
    <HeaderTop />
    <MenuPage />

    <BannerDetail
      :backgroundImage="require('../assets/img/banner2.jpg')"
      :title="$t('productssub3')"
      :description="$t('software2')"
    />
    <div class="product-main">
      <SoftItem />
    </div>
    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
import SoftItem from "@/components/SoftItem.vue";
export default {
  components: { HeaderTop, MenuPage, BannerDetail, SoftItem },
  name: "NewsPage",
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped>
.product-main {
  float: left;
  width: 100%;
  background: #f6f6f6;
  padding-bottom: 50px;
}
</style>
